//BAY Mini on UAT
import useDecodeToken from "@/utils/hooks/useDecodeJwt";
import dataManagement from "@/navigation/data-management";
import inventory from "@/navigation/inventory";
import privileges from "@/navigation/privileges";
import report from "@/navigation/report";
import banner from "@/navigation/banner";
import tags from "@/navigation/tags";
import fulfillment from "@/navigation/fulfillment";
import document from "@/navigation/document";
import article from "@/navigation/article";
import survey from "@/navigation/survey";

//custom module BAY Mini on UAT
import merchant from "@/constants/navigation/B1NJUHN5VWTO/menu/merchant";
import dashboard from "@/constants/navigation/B1NJUHN5VWTO/menu/dashboard";
import fulfillmentCustom from "@/constants/navigation/B1NJUHN5VWTO/menu/fulfillment";
import inventoryCustom from "@/constants/navigation/B1NJUHN5VWTO/menu/inventory";
import order from "@/constants/navigation/B1NJUHN5VWTO/menu/order";
import products from "@/constants/navigation/B1NJUHN5VWTO/menu/products";
import productsMerchant from "@/constants/navigation/B1NJUHN5VWTO/menu/provider-merchant/product-merchant";
//only dev
import dataManagementCustom from "@/constants/navigation/B1NJUHN5VWTO/menu/data-management-custom";
import merchantReport from "@/constants/navigation/B1NJUHN5VWTO/menu/merchant-report";

const { decodeToken } = useDecodeToken();
const renderNavByPermission = () => {
  switch (decodeToken()?.provider_ref) {
    case "PV0JYXfCAHp5z1": // Dev Bay-mini UAT KA
      return [
        ...products,
        ...order,
        ...inventoryCustom,
        ...fulfillmentCustom,
        ...dashboard,
        ...article,
        ...banner,
        ...report,
      ];
    case "PVvpZiWeRNO4XK": // Dev Bay-mini UAT Merchant
      return [
        ...merchant,
        ...productsMerchant,
        ...order,
        ...inventoryCustom,
        ...fulfillmentCustom,
        ...dataManagementCustom,
        ...merchantReport,
      ];
    case "PVPOk6L74V7Szi": // Dev Bay-mini UAT BO EP
      return [
        ...merchant,
        ...products,
        ...order,
        ...inventoryCustom,
        ...fulfillmentCustom,
        ...dashboard,
        ...article,
        ...banner,
        ...report,
      ];
    default:
      return [
        ...inventory,
        ...privileges,
        ...banner,
        ...fulfillment,
        ...report,
        ...dataManagement,
        ...article,
      ];
  }
};

export default renderNavByPermission();
